// A 1x1 lossy WebP. Safari only decodes WebP from macOS 11, and the warehouse iMac runs
// Safari 15 on Catalina: handed the WebP cutout it fails with "Failed to load image".
const WEBP_PROBE = 'data:image/webp;base64,UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA'
let webpDecodes = null

/** Whether this browser can decode WebP. Asked once, then remembered. */
export function browserDecodesWebp() {
  if (!webpDecodes) {
    webpDecodes = new Promise(resolve => {
      // A real browser answers at once. One that never answers (jsdom) is not Safari 15: assume WebP.
      setTimeout(() => resolve(true), 1000)
      const image = new Image()
      image.onload = () => resolve(image.width === 1)
      image.onerror = () => resolve(false)
      image.src = WEBP_PROBE
    })
  }
  return webpDecodes
}

/**
 * The body for POST /api/image/remove-background. A browser without WebP asks for
 * the PNG cutout instead (see workers/src/services/cutout.js).
 */
export async function removeBackgroundBody(imageUrl) {
  return { image_url: imageUrl, webp: await browserDecodesWebp() }
}
